/* =========================================================
   assets/hw-theme.js — HerWell theme interactions (vanilla JS)
   Every feature initialises from data-attributes, so sections work
   anywhere on any page and re-initialise in the theme editor.
   ========================================================= */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = window.routes || { cart_add_url: '/cart/add', cart_url: '/cart', root_url: '/' };
  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function once(el, key) { if (el.dataset['hw' + key]) return false; el.dataset['hw' + key] = '1'; return true; }

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = (window.HW && window.HW.moneyFormat) || '${{amount}}';
    cents = parseInt(cents, 10) || 0;
    function f(n, d, t, dec) {
      var s = (n / 100).toFixed(d).split('.');
      return s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (s[1] ? dec + s[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return f(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(cents, 0, '.', ',');
      return f(cents, 2, ',', '.');
    });
  }

  /* ---------- Toast + cart count ---------- */
  var toastT;
  function toast(msg, showLink) {
    var t = qs('#hw-toast'); if (!t) return;
    qs('span', t).textContent = msg;
    qs('a', t).style.display = showLink === false ? 'none' : '';
    t.classList.add('is-on'); clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('is-on'); }, 3600);
  }
  function setCount(n) {
    qsa('[data-hw-count]').forEach(function (el) {
      el.textContent = n; el.classList.add('is-bump');
      setTimeout(function () { el.classList.remove('is-bump'); }, 450);
    });
  }
  function refreshCount() {
    return fetch(routes.root_url.replace(/\/$/, '') + '/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; });
  }

  /* ---------- Add to cart (AJAX) ---------- */
  function addItems(body) {
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function busy(btn, on) { if (!btn) return; btn.classList.toggle('is-busy', on); if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy'); }
  function done(btn) {
    if (!btn) return; var label = btn.innerHTML;
    btn.classList.add('is-done'); btn.textContent = 'Added';
    setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = label; }, 1700);
  }
  function handleResult(res, btn, title) {
    busy(btn, false);
    if (!res.ok) { toast(res.j.description || res.j.message || 'Could not add this item.', false); return; }
    done(btn);
    var name = title || (res.j.items ? res.j.items[0].product_title : res.j.product_title) || 'Item';
    refreshCount().then(function (c) { document.dispatchEvent(new CustomEvent('herwell:cart-updated', { detail: c })); });
    toast(name + ' added to your cart.');
  }
  function addForm(form, btn) {
    var fd = new FormData(form);
    var id = fd.get('id'), qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    var item = { id: id, quantity: qty };
    if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
    busy(btn, true);
    return addItems({ items: [item] }).then(function (res) { handleResult(res, btn); })
      .catch(function () { busy(btn, false); toast('Something went wrong. Please try again.', false); });
  }
  window.HW = window.HW || {};
  window.HW.addForm = addForm;
  window.HW.toast = toast;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-hw-product-form]') || (form.matches('form[data-type="add-to-cart-form"]') && !form.closest('hwc-collection'))) {
      e.preventDefault();
      var btn = e.submitter && form.contains(e.submitter) ? e.submitter : qs('[type=submit]', form);
      if (btn && btn.disabled) return;
      addForm(form, btn);
    }
  });

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-hw-add]');
    if (add) {
      e.preventDefault(); busy(add, true);
      addItems({ items: [{ id: add.getAttribute('data-hw-add'), quantity: 1 }] })
        .then(function (res) { handleResult(res, add, add.getAttribute('data-hw-title')); })
        .catch(function () { busy(add, false); toast('Something went wrong. Please try again.', false); });
      return;
    }
    var w = e.target.closest('[data-hw-wish],[data-hwc-wish]');
    if (w && !(w.hasAttribute('data-hwc-wish') && w.closest('hwc-collection'))) {
      e.preventDefault();
      var h = w.getAttribute('data-hw-wish') || w.getAttribute('data-hwc-wish'), set = wishes(), on = !set[h];
      if (on) set[h] = 1; else delete set[h];
      try { localStorage.setItem('hwc-wishlist', JSON.stringify(set)); } catch (err) {}
      w.setAttribute('aria-pressed', String(on)); w.classList.remove('is-pop'); void w.offsetWidth; w.classList.add('is-pop');
      toast(on ? 'Saved to your wishlist.' : 'Removed from your wishlist.', false);
      return;
    }
    var q = e.target.closest('[data-hw-qty]');
    if (q) {
      var input = qs('input', q.closest('.hw-qty')); if (!input) return;
      var min = input.min === '' ? 1 : +input.min, max = input.max === '' ? 999 : +input.max;
      input.value = clamp((parseInt(input.value, 10) || 0) + parseInt(q.getAttribute('data-hw-qty'), 10), min, max);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  function wishes() { try { return JSON.parse(localStorage.getItem('hwc-wishlist') || '{}'); } catch (e) { return {}; } }

  /* ---------- Cart page: auto-update quantities ---------- */
  var cartT;
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-hw-cart-qty]')) return;
    var form = e.target.closest('form'); clearTimeout(cartT);
    cartT = setTimeout(function () { form.classList.add('is-loading'); form.submit(); }, 600);
  });

  /* ---------- Reveal ---------- */
  var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in'); io.unobserve(en.target);
      if (en.target.classList.contains('hw-stats')) runCounters(en.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }) : null;

  function runCounters(scope) {
    qsa('[data-hw-count-to]', scope).forEach(function (el) {
      var to = parseFloat(el.getAttribute('data-hw-count-to')) || 0, suf = el.getAttribute('data-hw-suffix') || '', t0 = null;
      if (reduce || !to) { el.textContent = to + suf; return; }
      function step(t) { if (!t0) t0 = t; var k = clamp((t - t0) / 1500, 0, 1), ee = 1 - Math.pow(1 - k, 4); el.textContent = Math.round(to * ee) + suf; if (k < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    });
  }

  /* ---------- Per-scope init (page load + theme editor reloads) ---------- */
  function init(scope) {
    scope = scope || document;
    var design = document.documentElement.classList.contains('shopify-design-mode');
    qsa('.hw', scope).concat(scope.classList && scope.classList.contains('hw') ? [scope] : []).forEach(function (el) { if (!design) el.classList.add('hw-js'); });
    qsa('[data-hw-reveal],[data-hw-inview]', scope).forEach(function (el) { if (io && !design) io.observe(el); else el.classList.add('is-in'); });
    qsa('.hw-stats', scope).forEach(function (el) {
      if (io && !design) { qsa('[data-hw-count-to]', el).forEach(function (n) { n.textContent = '0' + (n.getAttribute('data-hw-suffix') || ''); }); io.observe(el); }
    });
    qsa('[data-hw-announce]', scope).forEach(initAnnounce);
    qsa('[data-hw-header]', scope).forEach(initHeader);
    qsa('[data-hw-hero]', scope).forEach(initHero);
    qsa('[data-hw-rail]', scope).forEach(initRail);
    qsa('[data-hw-tilt]', scope).forEach(initTilt);
    qsa('.hw-hotspot', scope).forEach(initHotspot);
    qsa('[data-hw-tabs]', scope).forEach(initTabs);
    qsa('[data-hw-acc]', scope).forEach(initAcc);
    qsa('[data-hw-pdp]', scope).forEach(initPdp);
    qsa('.hw-form', scope).forEach(initNews);
    var set = wishes();
    qsa('[data-hw-wish],[data-hwc-wish]', scope).forEach(function (w) { var h = w.getAttribute('data-hw-wish') || w.getAttribute('data-hwc-wish'); if (set[h]) w.setAttribute('aria-pressed', 'true'); });
    collectScrollers();
    onScroll();
  }

  /* Announcement bar */
  function initAnnounce(bar) {
    if (!once(bar, 'Ann')) return;
    var msgs = qsa('.hw-announce__msg', bar); if (msgs.length < 2) return;
    var i = 0, paused = false, sec = bar.closest('.shopify-section'), speed = 5000;
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      var cur = msgs[i]; i = (i + 1) % msgs.length; var nxt = msgs[i];
      cur.classList.remove('is-active'); cur.classList.add('is-out'); cur.setAttribute('aria-hidden', 'true');
      nxt.classList.remove('is-out'); nxt.classList.add('is-active'); nxt.removeAttribute('aria-hidden');
      setTimeout(function () { cur.classList.remove('is-out'); }, 900);
    }, speed);
  }

  /* Header: scrolled / hide-on-scroll, search, drawer */
  var header = null, headerWrap = null, lastY = window.scrollY, drawerOpen = false;
  function initHeader(h) {
    header = h; headerWrap = h.closest('.section-header') || h.closest('.shopify-section');
    if (!once(h, 'Hdr')) return;
    var root = h.closest('.shopify-section') || document;
    var search = qs('#hw-search', root), sBtn = qs('[data-hw-search-open]', root), scrim = qs('[data-hw-scrim]', root);
    var drawer = qs('#hw-drawer', root), burger = qs('.hw-burger', root);
    function openSearch() { search.hidden = false; requestAnimationFrame(function () { search.classList.add('is-open'); scrim.classList.add('is-on'); }); sBtn.setAttribute('aria-expanded', 'true'); setTimeout(function () { qs('input[type=search]', search).focus(); }, 250); }
    function closeSearch() { search.classList.remove('is-open'); scrim.classList.remove('is-on'); sBtn.setAttribute('aria-expanded', 'false'); setTimeout(function () { search.hidden = true; }, 700); }
    if (search && sBtn) { sBtn.addEventListener('click', openSearch); qs('[data-hw-search-close]', search).addEventListener('click', function () { closeSearch(); sBtn.focus(); }); scrim.addEventListener('click', closeSearch); }
    function setDrawer(o) {
      drawerOpen = o; drawer.classList.toggle('is-open', o); burger.setAttribute('aria-expanded', String(o));
      document.documentElement.classList.toggle('hw-lock', o);
      if (o) setTimeout(function () { var f = qs('a', drawer); if (f) f.focus(); }, 300); else burger.focus();
    }
    if (drawer && burger) {
      burger.addEventListener('click', function () { setDrawer(!drawerOpen); });
      qs('[data-hw-drawer-close]', drawer).addEventListener('click', function () { setDrawer(false); });
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = qsa('a,button', drawer), a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawerOpen) setDrawer(false);
      if (search && search.classList.contains('is-open')) { closeSearch(); sBtn.focus(); }
    });
  }

  /* Hero entrance */
  function initHero(hero) {
    var img = qs('.hw-hero__img', hero);
    function go() { requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('is-loaded'); }); }); }
    if (!img || img.complete) go(); else { img.addEventListener('load', go); img.addEventListener('error', go); setTimeout(go, 1200); }
  }

  /* Mobile rail progress */
  function initRail(rail) {
    if (!once(rail, 'Rail')) return;
    var bar = rail.nextElementSibling; if (!bar || !bar.classList.contains('hw-rail-bar')) return;
    var s = bar.firstElementChild;
    function upd() { var w = rail.clientWidth / rail.scrollWidth || 1, max = rail.scrollWidth - rail.clientWidth, k = max > 0 ? rail.scrollLeft / max : 0; s.style.width = (w * 100) + '%'; s.style.transform = 'translateX(' + (k * (1 / w - 1) * 100) + '%)'; }
    rail.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }

  /* Story cards pointer parallax */
  function initTilt(card) {
    if (reduce || !window.matchMedia('(hover:hover)').matches || !once(card, 'Tilt')) return;
    var img = qs('img', card); if (!img) return;
    card.addEventListener('mousemove', function (e) { var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; img.style.setProperty('--mx', (x * -18).toFixed(1) + 'px'); img.style.setProperty('--my', (y * -18).toFixed(1) + 'px'); });
    card.addEventListener('mouseleave', function () { img.style.setProperty('--mx', '0px'); img.style.setProperty('--my', '0px'); });
  }

  function initHotspot(h) {
    if (!once(h, 'Hot')) return;
    var b = qs('button', h); b.addEventListener('click', function () { var o = h.classList.toggle('is-open'); b.setAttribute('aria-expanded', String(o)); });
  }

  /* Category tabs */
  function initTabs(sec) {
    if (!once(sec, 'Tabs')) return;
    var tabs = qsa('[role=tab]', sec), busyT = false;
    function show(tab) {
      if (busyT || tab.getAttribute('aria-selected') === 'true') return; busyT = true;
      var cur = qs('[role=tabpanel]:not([hidden])', sec), next = qs('#' + tab.getAttribute('aria-controls'), sec);
      tabs.forEach(function (t) { var on = t === tab; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
      var grid = cur && qs('.hw-cat__grid', cur);
      if (grid && !reduce) grid.classList.add('is-leaving');
      setTimeout(function () {
        if (cur) { cur.hidden = true; if (grid) grid.classList.remove('is-leaving'); }
        next.hidden = false;
        var cards = qsa('.hw-pcard', next);
        if (!reduce) { cards.forEach(function (c, i) { c.classList.add('is-entering'); c.style.transitionDelay = (i * 80) + 'ms'; });
          requestAnimationFrame(function () { requestAnimationFrame(function () { cards.forEach(function (c) { c.classList.remove('is-entering'); }); }); });
          setTimeout(function () { cards.forEach(function (c) { c.style.transitionDelay = ''; }); }, 900); }
        busyT = false;
      }, reduce ? 0 : 360);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t); });
      t.addEventListener('keydown', function (e) { var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return; e.preventDefault(); var n = tabs[(i + d + tabs.length) % tabs.length]; n.focus(); show(n); });
    });
  }

  /* FAQ — one open at a time */
  function initAcc(acc) {
    if (!once(acc, 'Acc')) return;
    var items = qsa('.hw-acc__item', acc);
    function set(it, o) { it.classList.toggle('is-open', o); qs('.hw-acc__btn', it).setAttribute('aria-expanded', String(o)); }
    items.forEach(function (it) { qs('.hw-acc__btn', it).addEventListener('click', function () { var o = !it.classList.contains('is-open'); items.forEach(function (x) { set(x, false); }); set(it, o); }); });
  }

  /* Newsletter: friendly validation */
  function initNews(box) {
    var form = box.closest('form'); if (!form || !once(form, 'News')) return;
    var input = qs('input[type=email]', form), msg = qs('.hw-form__msg', form);
    form.addEventListener('submit', function (e) {
      if (!input || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim())) return;
      e.preventDefault(); if (msg) { msg.textContent = 'Enter a valid email address, like name@example.com.'; msg.classList.add('is-error'); } input.focus();
    });
  }

  /* Product page: gallery + variants + sticky bar */
  function initPdp(pdp) {
    if (!once(pdp, 'Pdp')) return;
    var main = qs('.hw-main-img', pdp) || qs('.hw-gallery__main img', pdp);
    function showMedia(btn) {
      if (!btn || !main) return;
      qsa('.hw-gallery__thumbs button', pdp).forEach(function (b) { b.setAttribute('aria-current', String(b === btn)); });
      main.classList.add('is-fading');
      setTimeout(function () { main.src = btn.dataset.src; main.srcset = btn.dataset.srcset; main.alt = btn.dataset.alt; main.classList.remove('is-fading'); }, reduce ? 0 : 220);
    }
    qsa('.hw-gallery__thumbs button', pdp).forEach(function (b) { b.addEventListener('click', function () { showMedia(b); }); });

    var form = qs('[data-hw-product-form]', pdp), json = qs('[data-hw-variants]', pdp.parentNode) || qs('[data-hw-variants]');
    var variants = []; try { variants = JSON.parse(json.textContent); } catch (e) {}
    var idInput = qs('[data-hw-variant-id]', pdp), atc = qs('[data-hw-atc]', pdp), price = qs('[data-hw-price]', pdp);
    var sticky = qs('[data-hw-pdp-sticky]'), stickyPrice = sticky && qs('[data-hw-sticky-price]', sticky), stickyBtn = sticky && qs('button', sticky);
    function update() {
      var opts = qsa('[data-hw-option]', pdp).map(function (f) { var c = qs('input:checked', f); return c ? c.value : null; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      if (!v) { atc.disabled = true; atc.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      atc.disabled = !v.available; atc.textContent = v.available ? 'Add to Cart' : 'Sold out';
      if (stickyBtn) stickyBtn.disabled = !v.available;
      var html = '<b>' + formatMoney(v.price) + '</b>';
      if (v.compare_at_price > v.price) html += '<s>' + formatMoney(v.compare_at_price) + '</s><span class="hw-badge-sale">Sale</span>';
      price.innerHTML = html; if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (v.featured_media) { var b = qs('.hw-gallery__thumbs [data-media-id="' + v.featured_media.id + '"]', pdp); if (b) showMedia(b); }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
    }
    qsa('[data-hw-option] input', pdp).forEach(function (i) { i.addEventListener('change', update); });
    if (sticky) stickies.push({ el: sticky, area: pdp, btn: atc, btns: stickyBtn });
  }

  /* ---------- Scroll-linked effects (one rAF loop) ---------- */
  var parallax = [], steps = [], stickies = [], ticking = false;
  function collectScrollers() {
    parallax = qsa('.hw-hero__img, .hw-edit__media img');
    steps = qsa('[data-hw-steps]');
    qsa('[data-hw-spot]').forEach(function (spot) {
      var sec = spot.closest('.shopify-section') || spot.parentNode, st = qs('[data-hw-sticky]', sec);
      if (st && !st.dataset.hwStk) { st.dataset.hwStk = '1'; stickies.push({ el: st, area: spot, btn: qs('[data-hw-spot-atc]', spot), btns: qs('button', st) }); }
    });
  }
  function onScroll() {
    var y = window.scrollY, vh = window.innerHeight;
    if (header) {
      header.classList.toggle('is-scrolled', y > 12);
      if (headerWrap && !drawerOpen) {
        if (y > lastY + 4 && y > 720) headerWrap.classList.add('hw-hdr-hidden');
        else if (y < lastY - 4 || y < 720) headerWrap.classList.remove('hw-hdr-hidden');
      }
    }
    lastY = y;
    if (!reduce && window.innerWidth >= 768) parallax.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      el.style.setProperty('--py', ((r.top + r.height / 2 - vh / 2) * -0.1).toFixed(1) + 'px');
    });
    steps.forEach(function (st) {
      var sr = st.getBoundingClientRect(), vertical = window.innerWidth < 768, p;
      p = vertical ? clamp((vh * .62 - sr.top) / sr.height, 0, 1) : clamp((vh * .85 - sr.top) / (vh * .55), 0, 1);
      st.style.setProperty('--p', p.toFixed(3));
      var items = qsa('.hw-step', st);
      items.forEach(function (it, i) { var frac = vertical ? (it.offsetTop / st.offsetHeight) : (i / items.length); it.classList.toggle('is-active', reduce || p >= frac - .001); });
    });
    stickies.forEach(function (s) {
      var a = s.area.getBoundingClientRect(), b = s.btn ? s.btn.getBoundingClientRect() : { top: 0, bottom: 0 };
      var show = a.top < vh * .4 && a.bottom > vh * .3 && (b.bottom < 0 || b.top > vh);
      s.el.classList.toggle('is-on', show); s.el.setAttribute('aria-hidden', String(!show));
      if (s.btns) s.btns.tabIndex = show ? 0 : -1;
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener('resize', onScroll);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
